(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/bombenbutton.js') >= 0) return;  svs.modules.push('/modules/tipset/views/bombenbutton.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.bombenbutton = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "powerplay-bomben-no-bomben ";
},"3":function(container,depth0,helpers,partials,data) {
    return "powerplay-bomben-button";
},"5":function(container,depth0,helpers,partials,data) {
    return "Inget spel på ";
},"7":function(container,depth0,helpers,partials,data) {
    return "Köp till ett spel på ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.missingBomben : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + " row  js-bomben-game\">\n    <div class=\"powerplay-bomben-lable span9\">"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.missingBomben : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + " <i class=\"icon-coupon-default icon-coupon-bomben\"></i></div>\n    <div class=\"span2 powerplay-bomben-lable\">"
    + container.escapeExpression(((helper = (helper = helpers.bombenButtonMessage || (depth0 != null ? depth0.bombenButtonMessage : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"bombenButtonMessage","hash":{},"data":data}) : helper)))
    + "</div>\n    <div class=\"span1\"><i class=\"icon-default icon-100 icon-menu-right\"></i></div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-tipset-bombenbutton'] = svs.tipset.templates.bombenbutton;
})(svs, Handlebars);

 })(window);